import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Eye, Mail } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center space-x-3 mb-8">
              <Shield className="w-8 h-8 text-blue-400" />
              <h1 className="text-4xl font-bold">Privacy Policy</h1>
            </div>

            <div className="prose prose-invert max-w-none">
              <p className="text-lg text-gray-400 mb-8">
                Last updated: March 20, 2024
              </p>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <Lock className="w-6 h-6 mr-2 text-blue-400" />
                  Information We Collect
                </h2>
                <p className="mb-4">
                  We collect information that you provide directly to us, including:
                </p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li>Name and contact information</li>
                  <li>Payment information</li>
                  <li>Health and fitness information</li>
                  <li>Emergency contact details</li>
                  <li>Membership preferences</li>
                </ul>
                <p>
                  We also automatically collect certain information about your device when you use our services, including:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Device information</li>
                  <li>Usage information</li>
                  <li>Location information</li>
                </ul>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <Eye className="w-6 h-6 mr-2 text-blue-400" />
                  How We Use Your Information
                </h2>
                <p className="mb-4">We use the information we collect to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide and maintain our services</li>
                  <li>Process your payments</li>
                  <li>Send you important information</li>
                  <li>Improve our services</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4">Information Sharing</h2>
                <p className="mb-4">
                  We do not sell or rent your personal information to third parties. We may share your information with:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Service providers who assist in our operations</li>
                  <li>Professional advisers</li>
                  <li>Law enforcement when required by law</li>
                </ul>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4">Your Rights</h2>
                <p className="mb-4">You have the right to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Access your personal information</li>
                  <li>Correct inaccurate information</li>
                  <li>Request deletion of your information</li>
                  <li>Object to processing of your information</li>
                  <li>Withdraw consent</li>
                </ul>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4">Security</h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4">Cookies</h2>
                <p>
                  We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4">Changes to This Policy</h2>
                <p>
                  We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <Mail className="w-6 h-6 mr-2 text-blue-400" />
                  Contact Us
                </h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:{' '}
                  <a href="mailto:privacy@thefitnessportal.co.nz" className="text-blue-400 hover:text-blue-300">
                    privacy@thefitnessportal.co.nz
                  </a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
}